module.exports = __webpack_public_path__ + "d6142371cf5f9878214498c3e4be4047.jpg";